import { IconButton, styled } from "@mui/material";
import React from "react";
import IotVisionToolTips from "components/common/IotVisionToolTips";

interface IotVisionIconButtonProps {
    icon: React.ReactNode;
    onClick?: () => void;
    tooltip?: string;
    disabled?: boolean;
}

const StyledIconButton = styled(IconButton)(({ theme, disabled }) => ({
    borderRadius: "20px",
    height: "37px",
    border: "1px solid",
    borderColor: disabled ? theme.palette.text.disabled : theme.palette.primary.main,
    color: disabled ? theme.palette.text.disabled : theme.palette.primary.main,
    backgroundColor: "white",
}));

const IotVisionIconButton: React.FC<IotVisionIconButtonProps> = ({ icon, onClick, tooltip, disabled }) => {
    const button = (
        <StyledIconButton disabled={disabled} onClick={onClick}>
            {icon}
        </StyledIconButton>
    );

    if (!tooltip) {
        return button;
    }

    return (
        <IotVisionToolTips title={tooltip} PopperProps={{ disablePortal: true }} arrow>
            <span>{button}</span>
        </IotVisionToolTips>
    );
};

export default IotVisionIconButton;
